module.exports = __webpack_public_path__ + "img/view_3.9d953a8c.jpg";